import React, { useState, useEffect } from "react";
import TitleComp from "../components/Title/title";
import axios from "axios";
import DrawerComp from "../components/Drower/Drawer";
import { useDrawer } from "../context/drawer";
import { useSelector } from "react-redux";
import CardList from "../components/CardList/CardList";
import { Spin } from "antd";

export default function Categories() {
  const [fetchList, setFetchList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageComp, setPageComp] = useState(1);
  const [limitComp, setLimitComp] = useState(10);
  const [totalData, setTotalData] = useState(null);

  // =========================================== Drawer Context =========================

  const { drawerData, setDrawerData } = useDrawer();
  const { token } = useSelector((state) => state.auth);

  const fetchData = async (page, limit) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://1fiveglobal.com/api/category.php?action=fetch&admin_token=OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH`
      );

      if (response.data) {
        setLoading(false);
        setFetchList(response.data.list);
        setTotalData(response.data.filteredTotal);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error making get request", error);
    }
  };

  useEffect(() => {
    fetchData(pageComp, limitComp);
  }, [pageComp, limitComp]);

  // ======================= Handle Drawer Add =================================

  const handleDrawerAdd = () => {
    setDrawerData({
      ...drawerData,
      isOpen: true,
      type: "clientAdd",
      title: "Category Add",
      ID: null,
    });
  };

  return (
    <div>
      <TitleComp
        name="Category List"
        handleDrawerAdd={handleDrawerAdd}
        totalData={totalData}
        type="Category"
      />
      <Spin spinning={loading}>
        <CardList
          limitComp={limitComp}
          pageComp={pageComp}
          setPageComp={setPageComp}
          totalData={totalData}
          setLimitComp={setLimitComp}
          loading={loading}
          fetchData={fetchData}
          fetchList={fetchList}
        />
      </Spin>
      <DrawerComp />
    </div>
  );
}
